import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { toast } from 'react-toastify';
import api from '../utils/api';

export const getAllProductsThunk = createAsyncThunk(
  'product/getAllProducts',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllProduct(config);
      // console.log("resss", response.data);

      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);


export const exportProductsthunk = createAsyncThunk(
  'product/exportProductsthunk',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.exportAllProducts();
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getProductDetails = createAsyncThunk(
  'product/getProductDetails',
  async (id, { rejectWithValue }) => {
    try {
      const { data, status } = await api.getProductDetails(id);
      // console.log("resss", response.data);

      return data.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);



export const deleteProductThunk = createAsyncThunk(
  'product/deleteProduct',
  async (payload, { rejectWithValue, dispatch }) => {
    try {

      const id = payload?.id ?? payload;
      const password = payload?.password;
      const response = await api.deleteProduct(id, password);
      dispatch(setProductRefresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

export const addProductThunk = createAsyncThunk(
  'product/addProductThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.addProduct(data);
      dispatch(setProductRefresh())
      toast.success(response.data?.data?.message || 'Data added successfully')
      return response.status;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);




export const updateProductThunk = createAsyncThunk(
  'product/updateProductThunk',
  async (productData, { rejectWithValue,dispatch }) => {
    try {
      const { data, status } = await api.editProduct(productData);
      dispatch(setProductRefresh())
      toast.success(data?.data?.message || "Product updated successfully")
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')
    }
  }
);

export const updateProductInventory = createAsyncThunk(
  'product/updateProductInventory',
  async (productData, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data, status } = await api.upadteInventory(productData);
      dispatch(setProductRefresh());
      const { page } = getState().products;
      dispatch(getAllProductsThunk(`?search=&page=${page || 1}&status=&limit=25&sortBy=createdAt&order=asc`));
      if (productData?.id) {
        dispatch(getProductDetails(productData.id));
      }
      toast.success(data?.message || data?.data?.message || "Product inventory updated successfully");
      return status;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong');
    }
  }
);




export const BulkUploadProductThunk = createAsyncThunk(
  'product/BulkUploadProduct',
  async (productData, { rejectWithValue, dispatch }) => {
    try {
      if (!Array.isArray(productData) || productData.length === 0) {
        toast.error("No products to upload");
        return 400;
      }

      const CHUNK_SIZE = 200;
      const CONCURRENCY = 2;
      const totalProducts = productData.length;
      let totalInserted = 0;
      let totalUpdated = 0;
      let allFailed = [];
      let lastStatus = 200;
      let processedCount = 0;

      dispatch(setUploadProgress({ current: 0, total: totalProducts }));

      const chunks = [];
      for (let i = 0; i < totalProducts; i += CHUNK_SIZE) {
        chunks.push(productData.slice(i, i + CHUNK_SIZE));
      }

      let chunkIndex = 0;
      const runWorker = async () => {
        while (chunkIndex < chunks.length) {
          const currentIndex = chunkIndex++;
          const chunk = chunks[currentIndex];
          try {
            const response = await api.bulkuploadProduct(chunk);
            lastStatus = response.status;
            const result = response.data?.data;
            if (result) {
              totalInserted += result.inserted || 0;
              totalUpdated += result.updated || 0;
              if (result.failed && result.failed.length > 0) {
                allFailed.push(...result.failed);
              }
            }
          } catch (err) {
            allFailed.push({
              name: `Batch ${currentIndex + 1}`,
              reason: err?.response?.data?.message || err?.message || "Request failed"
            });
          } finally {
            processedCount = Math.min(processedCount + chunk.length, totalProducts);
            dispatch(setUploadProgress({ current: processedCount, total: totalProducts }));
          }
        }
      };

      const workers = Array.from({ length: Math.min(CONCURRENCY, chunks.length) }, () => runWorker());
      await Promise.all(workers);

      if (allFailed.length > 0) {
        const totalSuccess = totalInserted + totalUpdated;
        const errorMsg = allFailed.map(f => `${f.name}: ${f.reason}`).slice(0, 2).join(', ');
        if (totalSuccess === 0) {
          toast.error(`Failed to upload products. Errors: ${errorMsg}`);
          return rejectWithValue(allFailed);
        } else {
          toast.warning(`Uploaded ${totalSuccess} products. ${allFailed.length} failed. Sample error: ${errorMsg}`);
        }
      } else {
        toast.success(`Successfully uploaded ${totalInserted} new and updated ${totalUpdated} existing products!`);
      }

      dispatch(setProductPage(1));
      dispatch(setProductRefresh());
      return { status: lastStatus, failedCount: allFailed.length };
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong');
      return rejectWithValue(error);
    }
  }
);

export const getAttributesAddProdThunk = createAsyncThunk(
  'atribute/getAttributesAddProdThunk',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAttributesAddProd(config);
      return response.data?.data || { attributeOptions: [], valueOptions: {} };
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getProductThunk = createAsyncThunk(
  'getProductThunk/getProductThunk',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getProd(config);
      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const deletemultipleProductsThunk = createAsyncThunk(
  'categories/deletemultipleProductsThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.deletemultipleProducts(data);
      dispatch(setProductRefresh())
      dispatch(setSelectedproductids([]))
      dispatch(setSelectallproduct(false))
      dispatch(setAllProductsSelected(false))
      dispatch(setAllProductsFilters(null))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

// Slice for categories
const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    products: [],
    refresh: false,
    loading: false,
    error: null,
    editProduct: null,
    exportedData: [],
    exportLoading: false,
    bulkUploadData: [],
    atributes: { attributeOptions: [], valueOptions: {} },
    productsdrop: [],
    productDetails: null,
    page:1,
    selectedIds:[],
    selectAll:false,
    allProductsSelected: false,
    allProductsFilters: null,
    uploadProgress: { current: 0, total: 0 }
  },
  reducers: {

    setProductRefresh: (state, action) => {
      state.refresh = !state.refresh;
    },
    setEditProduct: (state, action) => {
      state.editCategory = action.payload;
    },
    setBulkUploadData: (state, action) => {
      state.bulkUploadData = action.payload
    },
    deleteProduct: (state, action) => {
      state.bulkUploadData = state.bulkUploadData.filter(
        (product) => product["Serial No"] !== action.payload
      );
    },
    setProductPage:(state,action)=>{
      state.page = action.payload
    },
    setSelectedproductids:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectallproduct:(state,action) =>{
      state.selectAll = action.payload
    },
    setAllProductsSelected:(state,action) =>{
      state.allProductsSelected = action.payload
    },
    setAllProductsFilters:(state,action) =>{
      state.allProductsFilters = action.payload
    },
    clearProductSelection:(state) =>{
      state.selectedIds = []
      state.selectAll = false
      state.allProductsSelected = false
      state.allProductsFilters = null
    },
    setUploadProgress:(state,action) =>{
      state.uploadProgress = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProductsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllProductsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getAllProductsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      //getProductDetails
      .addCase(getProductDetails.pending, (state) => {
        state.loading = true;
        state.productDetails = null;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetails = action.payload || null;
      })
      .addCase(getProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.productDetails = null;
      })

      //export category
      .addCase(exportProductsthunk.pending, (state) => {
        state.exportLoading = true;
        state.error = null;
      })
      .addCase(exportProductsthunk.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportedData = action.payload;
      })
      .addCase(exportProductsthunk.rejected, (state, action) => {
        state.exportLoading = false;
        state.error = action.payload;
      })

      //export category
      .addCase(BulkUploadProductThunk.pending, (state) => {
        state.loading = true;
        state.uploadProgress = { current: 0, total: 0 };
      })
      .addCase(BulkUploadProductThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(BulkUploadProductThunk.rejected, (state, action) => {
        state.loading = false;
      })


      .addCase(getAttributesAddProdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAttributesAddProdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.atributes = action.payload || { attributeOptions: [], valueOptions: {} };
      })
      .addCase(getAttributesAddProdThunk.rejected, (state, action) => {
        state.loading = false;
        if (!state.atributes || Object.keys(state.atributes).length === 0) {
          state.atributes = { attributeOptions: [], valueOptions: {} };
        }
      })

      .addCase(getProductThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.productsdrop = action.payload
      })
      .addCase(getProductThunk.rejected, (state, action) => {
        state.loading = false;
      })


  },
});

export const { setProductRefresh, setBulkUploadData, deleteProduct,setProductPage,setSelectedproductids,setSelectallproduct,setAllProductsSelected,setAllProductsFilters,clearProductSelection,setUploadProgress } = categoriesSlice.actions
export default categoriesSlice.reducer;

